import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5001 5.66657C11.5001 6.31115 10.9781 6.83323 10.3335 6.83323C9.6889 6.83323 9.16681 6.31115 9.16681 5.66657C9.16681 5.02198 9.6889 4.4999 10.3335 4.4999C10.9781 4.4999 11.5001 5.02198 11.5001 5.66657ZM14.8292 14.829C14.7155 14.9427 14.5661 14.9999 14.4168 14.9999C14.2675 14.9999 14.1181 14.9427 14.0044 14.829L1.17106 1.99565C0.942979 1.76757 0.942979 1.3989 1.17106 1.17082C1.39915 0.942735 1.76781 0.942735 1.9959 1.17082L2.8919 2.06682C3.36673 1.75299 3.92498 1.58323 4.50015 1.58323H11.5001C13.1084 1.58323 14.4168 2.89165 14.4168 4.4999V11.4999C14.4168 12.0757 14.2471 12.6339 13.9332 13.1082L14.8292 14.0042C15.0573 14.2322 15.0573 14.6009 14.8292 14.829ZM3.7459 2.92082L13.0792 12.2542C13.1906 12.0208 13.2501 11.763 13.2501 11.4999V4.4999C13.2501 3.53507 12.465 2.7499 11.5001 2.7499H4.50015C4.23706 2.7499 3.97981 2.8094 3.7459 2.92082ZM10.9168 13.2499H4.50015C3.61173 13.2499 2.87673 12.5849 2.76531 11.7262L5.4959 8.99565C5.72398 8.76757 5.72398 8.3989 5.4959 8.17082C5.26781 7.94273 4.89915 7.94273 4.67106 8.17082L2.75015 10.0917V5.08323C2.75015 4.76065 2.48881 4.4999 2.16681 4.4999C1.84481 4.4999 1.58348 4.76065 1.58348 5.08323V11.4999C1.58348 13.1082 2.8919 14.4166 4.50015 14.4166H10.9168C11.2388 14.4166 11.5001 14.1558 11.5001 13.8332C11.5001 13.5107 11.2388 13.2499 10.9168 13.2499Z"
      fill="black"
    />
  </svg>
);

const ImageRemoveIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ImageRemoveIcon;
